module.exports = __webpack_public_path__ + "static/media/pocket-kit-02.6cb038b6.png";